export default __webpack_public_path__ + "static/media/EVERGATE.766b4a1c.jpg";